import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import {Table, TableModule} from 'primeng/table';
import {FormsModule} from '@angular/forms';
import {
  DatePipe,
  NgClass,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
  NgTemplateOutlet, SlicePipe,
  TitleCasePipe
} from '@angular/common';
import {Avatar} from 'primeng/avatar';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {DropdownModule} from 'primeng/dropdown';
import {TableColumn, TableFilter, TableLazyEvent} from '../../contracts/table-column.interface';
import {Tooltip} from 'primeng/tooltip';
import {FloatLabel} from 'primeng/floatlabel';
import {Select} from 'primeng/select';
import {Tag} from 'primeng/tag';
import {RoleEnum} from '../../contracts/role.interface';

@Component({
  selector: 'kc-data-table',
  imports: [
    TableModule,
    FormsModule,
    NgSwitch,
    Avatar,
    Button,
    NgSwitchDefault,
    NgSwitchCase,
    DropdownModule,
    InputText,
    Tooltip,
    NgTemplateOutlet,
    FloatLabel,
    Select,
    DatePipe,
    Tag,
    NgClass,
    TitleCasePipe,
    SlicePipe,
  ],
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss'
})
export class DataTableComponent implements OnInit, OnChanges {

  @Input() value: any[] = [];
  @Input() columns: TableColumn[] = [];
  @Input() enableSearch: boolean = false;
  @Input() enableFilterReset: boolean = true;
  @Input() enableSelection: boolean = false;
  @Input() showHeader: boolean = true;

  @Input() totalRecords = 0;
  @Input() rows = 10;

  @Output() onLazyLoad = new EventEmitter<TableLazyEvent>();

  @Output() selectionChange = new EventEmitter<any[]>();

  @ContentChild("customCaption") customCaption!: TemplateRef<any>;
  @Input() topbarTemplate?: TemplateRef<any>;

  selectedItems: any[] = [];

  searchValue: string = '';
  globalFilterFields: string[] = [];


  ngOnInit() {
    this.prepareGlobalFilterFields();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['columns'] && changes['columns'].currentValue?.length > 0) {
      this.prepareGlobalFilterFields();
    }
  }

  clear(table: Table) {
    table.clear();
    this.searchValue = ''
  }

  selectedOption(event: any, row: any, column: TableColumn) {
    column.dropdown!.onSelectDropdown!(event.value, row);
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  }

  setNestedValue(obj: any, path: string, value: any): void {
    const parts = path.split('.');
    const last = parts.pop()!;
    const target = parts.reduce((acc, part) => acc?.[part], obj);
    if (target) {
      target[last] = value;
    }
  }

  prepareGlobalFilterFields() {
    if (this.enableSearch) {
      this.globalFilterFields = this.columns.filter(col => col.field && col.filterable == true).map(col => col.field!);
    }
  }

  handleLazyLoad(rawEvent: any): void {
    const page = Math.floor(rawEvent.first / rawEvent.rows) + 1;
    const filters: TableFilter[] = [];
    let search: string | undefined;

    if (rawEvent.filters) {
      const globalFilter = rawEvent.filters['global'];
      if (globalFilter?.value != null && String(globalFilter.value).trim() !== '') {
        search = String(globalFilter.value).trim();
      }

      for (const col of this.columns) {
        if (!col.filterable || !col.field) continue;
        const constraint = rawEvent.filters[col.field];
        if (!constraint) continue;
        const arr: any[] = Array.isArray(constraint) ? constraint : [constraint];
        for (const c of arr) {
          const val = c?.value;
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            const fields = col.filterFields?.length ? col.filterFields : [col.field!];
            for (const field of fields) {
              filters.push({
                field,
                value: String(val).trim(),
                matchMode: c.matchMode ?? 'contains',
              });
            }
          }
        }
      }
    }

    this.onLazyLoad.emit({ page, rows: rawEvent.rows, filters, search });
  }

}
